import { useEffect, useState } from 'react'
import { api } from '../../api/client'

const money = (n: number) => n.toLocaleString(undefined, {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4})

export default function EngagementSpend() {
  const [offset, setOffset] = useState(0)
  const [data, setData] = useState<Awaited<ReturnType<typeof api.engagementSpend>> | null>(null)
  const [error, setError] = useState('')
  useEffect(() => {
    let live = true
    let timer: number | undefined
    const refresh = async () => {
      try {
        const value = await api.engagementSpend(offset)
        if (live) { setData(value); setError('') }
      } catch (e) { if (live) setError(e instanceof Error ? e.message : 'Could not load engagement costs') }
      finally { if (live) timer = window.setTimeout(refresh, 10000) }
    }
    void refresh()
    return () => { live = false; window.clearTimeout(timer) }
  }, [offset])
  function page(next: number) { setData(null); setError(''); setOffset(next) }
  return <section className="panel">
    <h2>By engagement</h2>
    <p className="muted">Each cost is counted once. Reusing existing research does not create another charge. Shared and historical costs without an engagement stay in the lifetime total.</p>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {!data ? <p className="muted">{error ? 'Retrying engagement costs…' : 'Loading engagement costs…'}</p> : <>
      {!data.rows.length ? <p className="muted">No engagement costs on this page.</p> : <div className="table-wrap"><table className="data">
        <thead><tr><th>Engagement</th><th>Confirmed</th><th>Estimated</th><th>Reserved</th><th>Total exposure</th><th>Unpriced events</th><th>Events</th></tr></thead>
        <tbody>{data.rows.map(row => <tr key={row.engagement_id ?? 'shared'}>
          <td className="wrap">{row.name}{row.engagement_id === null && <div className="muted">Not assigned to an engagement</div>}</td>
          <td>{money(row.actual_usd)}</td><td>{money(row.estimated_usd)}</td><td>{money(row.reserved_usd)}</td><td>{money(row.committed_usd)}</td><td>{row.unpriced_events.toLocaleString()}</td><td>{row.events.toLocaleString()}</td>
        </tr>)}</tbody>
      </table></div>}
      <div className="action-group">
        <button className="btn small secondary" disabled={offset === 0} onClick={() => page(Math.max(0, offset - 25))}>Previous engagements</button>
        <span>{data.rows.length ? offset + 1 : 0}–{data.rows.length ? offset + data.rows.length : 0} of {data.total.toLocaleString()}</span>
        <button className="btn small secondary" disabled={offset + 25 >= data.total} onClick={() => page(offset + 25)}>Next engagements</button>
      </div>
    </>}
  </section>
}
